import { z } from 'zod';

/////////////////////////////////////////
// CORE INTEGRATION DATA SYNC MAPPING VALUE SCHEMA
/////////////////////////////////////////

export const CoreIntegrationDataSyncMappingValueSchema = z.object({
  id: z.number().int(),
  cityId: z.number().int(),
  mappingId: z.number().int(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  gogovFieldName: z.string().nullable(),
  gogovFieldId: z.bigint().nullable(),
  gogovValue: z.string().nullable(),
  externalFieldName: z.string().nullable(),
  externalFieldId: z.string().nullable(),
  externalValue: z.string().nullable(),
})

export type CoreIntegrationDataSyncMappingValue = z.infer<typeof CoreIntegrationDataSyncMappingValueSchema>

export default CoreIntegrationDataSyncMappingValueSchema;
